import './post.scss'

import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { formatDate } from '../../utils'
import { InnerHtml, Link } from '../global'

const PostHeader = ({ type, header, date, image = {}, cats = [] }) => {
  if (type === 'hero') return null

  const formattedDate = formatDate(date)

  const labelClass = classNames({
    'label-orange': cats[0]?.slug === 'bloggar',
    'label-green': cats[0]?.id === 'dGVybToxMjk4NQ==', 
    'label-blue': cats[0]?.id === 'dGVybToy',
    'label-gray': !['dGVybToz', 'dGVybToxMjk4NQ==', 'dGVybToy'].includes(cats[0]?.id),
  })

  return (
    <Fragment>
      <div className="post-header">
        <div className="post-info">
          {cats.length && (
            <Link className={labelClass} to={cats[0]['uri']}>
              {cats[0]['name']}
            </Link>
          )}
          <span className="post-date dark">{formattedDate}</span>
        </div>
        <h1>{header}</h1>
      </div>
      {image && (
        <div className="post-image">
          <img src={image.sourceUrl} alt={image.altText} />
          <div className="image-details">
            {image.description && (
              <InnerHtml
                className="image-caption"
                content={image.description}
              />
            )}
          </div>
        </div>
      )}
    </Fragment>
  )
}

PostHeader.propTypes = {
  type: PropTypes.oneOf(['hero', 'small', 'none']),
  header: PropTypes.string,
  date: PropTypes.string,
  image: PropTypes.shape({
    altText: PropTypes.string,
    sourceUrl: PropTypes.string,
    description: PropTypes.string,
  }),
  cats: PropTypes.arrayOf(
    PropTypes.shape({ uri: PropTypes.string, name: PropTypes.string }),
  ),
}

export default PostHeader
